import styled from 'styled-components';

const FieldWrapper = styled.div``;
const InputWrapper = styled.div``;

const FormFieldWrappers = {
  FieldWrapper,
  InputWrapper,
};

export default FormFieldWrappers;
